import { SalesCallListTable } from "../SalesCallListTable";
import { Button, DataSource, HorizontalSpacer, Layout, LayoutHeader, Panel, SearchButton, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallList extends Layout {
    buttonClear: Button;
    buttonConvert: Button;
    horizontalspacer1: HorizontalSpacer;
    layoutAll: SalesCallListTable;
    layoutToday: SalesCallListTable;
    layoutheaderSalesCallList: LayoutHeader;
    panelSearch: Panel;
    searchbuttonSearch: SearchButton;
    sourceSalesCallRecord: DataSource;
    sourceSalesCalls: DataSource;
    switchSearchAllCSR: Switch;
    switchSearchAllCustomers: Switch;
    switchSearchAllLocations: Switch;
    tabAll: Tab;
    tabHistory: Tab;
    tabToday: Tab;
    tableCallRecords: Table;
    tabsetMain: Tabset;
    textboxAssignedTo: Textbox;
    textboxCustomer: Textbox;
    textboxLocation: Textbox;
    textboxSalesperson: Textbox;
    textboxStatusFilter: Textbox;
}
